export default __webpack_public_path__ + "static/media/1718.cb048e0c.png";